import Forms from "./forms";
import { Routes } from "./routes";

const Authentication = {
	install(Vue, { router }) {
		Vue.use(Forms);
		// example of adding store module dynamically
		// if (!options || !options.store) {
		// 	throw new Error("Please initialise plugin with a Vuex store.");
		// }

		// options.store.registerModule("testModule", testModule);

		if (router) {
			Routes.forEach((route) => {
				router.addRoute(route);
			});
		}
	}
};

// Finally export as default
export default Authentication;
